<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66732 14.6666H3.33398C2.00065 14.6666 1.33398 13.9999 1.33398 12.6666V7.33325C1.33398 5.99992 2.00065 5.33325 3.33398 5.33325H6.66732V12.6666C6.66732 13.9999 7.33398 14.6666 8.66732 14.6666Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.74064 2.66675C6.68731 2.86675 6.66732 3.08675 6.66732 3.33341V5.33341H3.33398V4.00008C3.33398 3.26675 3.93398 2.66675 4.66732 2.66675H6.74064Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33398 5.33325V8.66659"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 5.33325V8.66659"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.334 11.3333H10.0007C9.63398 11.3333 9.33398 11.6333 9.33398 11.9999V14.6666H12.0007V11.9999C12.0007 11.6333 11.7007 11.3333 11.334 11.3333Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 8.66675V11.3334"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66602 12.6666V3.33325C6.66602 1.99992 7.33268 1.33325 8.66602 1.33325H12.666C13.9993 1.33325 14.666 1.99992 14.666 3.33325V12.6666C14.666 13.9999 13.9993 14.6666 12.666 14.6666H8.66602C7.33268 14.6666 6.66602 13.9999 6.66602 12.6666Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "my-office",
};
</script>

<style lang="scss" scoped></style>
